import NetPrice from './NetPrice';
import Shop from './Shop';
import RepresentativeUser from './RepresentativeUser';
import Location from './Location';
import ShopVisits from './ShopVisits';

export const labels = {
  NetPrice: 'Nettó',
  Shop: 'Üzlet',
  RepresentativeUser: 'Képviselő',
  Location: 'Terület',
  ShopVisits: 'Látogatások',
};

export const allColumns = [{
  value: 'NetPrice',
}, {
  value: 'Shop',
}, {
  value: 'RepresentativeUser',
}, {
  value: 'ShopVisits',
}, {
  value: 'Location',
}];

export const defaultColumns = [{
  value: 'Shop',
  fixed: true,
}, {
  value: 'RepresentativeUser',
}, {
  value: 'Location',
}, {
  value: 'ShopVisits',
}, {
  value: 'NetPrice',
  fixed: true,
}];

export const defaultSort = {
  prop: NetPrice.propName,
  order: 'descending'
};

export default {
  NetPrice,
  Shop,
  RepresentativeUser,
  Location,
  ShopVisits,
};
